import React, { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const PasswordInput = ({
  placeholder = "Enter your password",
  inputContStyle = {},
  inputStyle = {},
  iconStyle = {},
  onPasswordChange,
}) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    if (onPasswordChange) {
      onPasswordChange(newPassword);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        border: "1px solid var(--light-grey)",
        borderRadius: "8px",
        padding: " 5px 5px",
        background: "var(--white-color)",
        ...inputContStyle,
      }}
    >
      <input
        type={showPassword ? "text" : "password"}
        value={password}
        onChange={handlePasswordChange}
        placeholder={placeholder}
        style={{
          padding: "8px",
          flex: 1,
          ...inputStyle,
          border: "none",
          outline: "none",
          background: "var(--white-color)",
        }}
      />
      {showPassword ? (
        <VisibilityOff
          onClick={togglePasswordVisibility}
          style={{ marginLeft: "8px", cursor: "pointer", ...iconStyle }}
        />
      ) : (
        <Visibility
          onClick={togglePasswordVisibility}
          style={{ marginLeft: "8px", cursor: "pointer", ...iconStyle }}
        />
      )}
    </div>
  );
};

export default PasswordInput;
